var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_6779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.35497 8.10435C2.62515 8.30754 2.61635 9.32379 3.33973 9.78073L8.62831 13.1161C8.76116 13.2 8.90953 13.2466 9.05499 13.2501C9.20044 13.2537 9.33658 13.214 9.44649 13.1359L15.0428 9.15612C15.2042 9.04048 15.4412 9.27745 15.3261 9.43947L11.3462 15.0347C11.2682 15.1446 11.2285 15.2808 11.232 15.4262C11.2356 15.5717 11.2822 15.7201 11.3661 15.8529L14.7033 21.1443C15.1596 21.8671 16.1759 21.8583 16.3796 21.129L20.9272 4.84817C21.1282 4.12972 20.3543 3.35582 19.6352 3.55624L3.35497 8.10435Z",
    fill: "#A3A9B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_6779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSend);
export default __webpack_public_path__ + "static/media/mobile-send.f8140a58e0ed1e8857ae4167ef0f1c09.svg";
export { ForwardRef as ReactComponent };